import Swal from "sweetalert2";
import Vue from 'vue'
import {utils} from "./utils";
import {responses} from "./responses";
import {errorHandler} from "./errorHandler";
import queryStringify from "qs-stringify";


window.backOfficeTomcatApi = `https://overflow.abc.co.zm/Lyt-SoftBackOfficeApi/`
// window.backOfficeTomcatApi = `http://localhost:8080/Lyt-SoftBackOfficeApi/`

window.franchiseTomcatApi = `https://overflow.abc.co.zm/Franchise_OnlineServer/`
//window.franchiseTomcatApi = `https://realtime.abc.co.zm:8443/Franchise_OnlineServer/`
// window.franchiseTomcatApi = `http://192.168.1.228:8080/Franchise_OnlineServer/`

window.wareHouseTomcatApi = `https://lna.abc.co.zm/WarehouseManager1/`
// window.wareHouseTomcatApi = `http://192.168.0.193:9020/WarehouseManager/`
// window.wareHouseTomcatApi = `http://oscar:8080/WarehouseManager/`

window.navTomcatApi = wareHouseTomcatApi+`nav/`

// Public base URL for generating shareable WarehouseManager links (do not change API base above)
// Used to build URLs like: https://lna.abc.co.zm/WarehouseManager/nav/checkout/pallet?palletNumber=...
window.wareHousePublicTomcatApi = `https://lna.abc.co.zm/WarehouseManager1/`;
window.navPublicTomcatApi = wareHousePublicTomcatApi + `nav/`;

// Hardware API endpoint for posting pallet link payloads
// Default to local hardware service during development; can be overridden before this file loads
// Example override in index.html: <script>window.hardwareApi = 'https://devices.abc.co.zm/api/'</script>
window.hardwareApi = window.hardwareApi || `http://localhost:9090/`;
// window.navTomcatApi = `http://192.168.1.141:8080/Franchise_OnlineServer/nav/`

window.responses = responses;
window.errorHandler = errorHandler

const EventBus = new Vue()
window.EventBus = EventBus

window.log = (val) => console.log(val);
window.Swal = Swal;

window.generateUUID = () => {
    let uuid = '', i, random;
    for (i = 0; i < 32; i++) {
        random = Math.random() * 16 | 0;
        if (i === 8 || i === 12 || i === 16 || i === 20) {
            uuid += '-';
        }
        uuid += (i === 12 ? 4 : (i === 16 ? (random & 3 | 8) : random)).toString(16);
    }
    return uuid;
}

Vue.prototype.$utils = utils;
window.$utils = utils;

const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 1500,
    showCloseButton: true,
    customClass: 'toastr',
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
});
window.Toast = Toast;
window.stringify = (object) => queryStringify(object);
window.openUrl = (url,target = '_blank') => window.open(url,target);